export default "__VITE_ASSET__DH8t0RxT__"